module.exports = __webpack_public_path__ + "images/category_lp/retro_game/store_images/3@2x_acb37122ccc69bbec9c00ae1876b997a.png";